import _Button from './Button';

import './style/index.js';

export * from './type';

export const Button = _Button;

export default Button;
